module.exports = __webpack_public_path__ + "img/free-video-bottom-button.dce20d34.png";